
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { Box, IconButton, Slider, Typography } from "@mui/material";
import NavigationRefresh from '@mui/icons-material/Refresh';
import moment from "moment-timezone";
import { fillDateGaps } from "../data-utils";
import { apiRoutes, fetchJson } from "@/src/services";
import { buildQueryUrl } from "@/src/utils";


const validClids = ["gclid", "ysclid", "fbclid"] as const;
const allClids = [...validClids, "none"] as const;
type Cild = typeof allClids[number];


type SourceRecord = { _id: string | Date } & Record<Cild | "none", number | undefined>

type SourceData = Record<"male" | "female", SourceRecord[]>


interface Props {
    timezone: string,

}

const colors: string[] = ['#B80000', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#DB3E00', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'];

export const NewByGenderClid = ({ timezone }: Props) => {
    const [days, setDays] = useState(30);
    const { data, refetch } = useQuery<SourceData>({
        queryKey: ['new-by-gender-clid', days, timezone],
        queryFn: () =>
            fetchJson(buildQueryUrl(apiRoutes.dashboard.newByGenderClid2, { days, timezone, clids: validClids }))
                .then(resp => {
                    return resp.json
                }),
        staleTime: Infinity,
        refetchOnWindowFocus: false
    }
    );


    return (
        <Box>
            <IconButton onClick={() => refetch()} aria-label="refresh" color="primary"><NavigationRefresh /></IconButton>
            <Typography variant="h6" align="center">Registrations By AdSource</Typography>
            <Typography variant="subtitle2">Male</Typography>
            <ResponsiveContainer width="100%" height={140}>
                <LineChart data={data?.male} margin={{ top: 10, right: 10, left: -20, bottom: 0 }} syncId={"new-by-gender-clid"}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="_id"
                        tick={{ fontSize: 12 }}
                        tickFormatter={(value) => (!value || value === "auto") ? value : moment(value).tz(timezone).format('D MMM')}
                    />
                    <YAxis tick={{ fontSize: 12 }} />
                    <Tooltip
                        labelFormatter={(value: any) => moment(value).tz(timezone).format('D MMM')}
                    />
                    {/* <Legend /> */}
                    {allClids.map((key, index) =>
                        <Line key={key} dataKey={key} stroke={key == "none" ? "#aaa" : colors[index]} />)
                    }
                </LineChart>
            </ResponsiveContainer>
            <Typography variant="subtitle2">Female</Typography>
            <ResponsiveContainer width="100%" height={140 + 20}>
                <LineChart data={data?.female} margin={{ top: 0, right: 10, left: -20, bottom: 0 }} syncId={"new-by-gender-clid"}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="_id"
                        tick={{ fontSize: 12 }}
                        tickFormatter={(value) => (!value || value === "auto") ? value : moment(value).tz(timezone).format('D MMM')}
                    />
                    <YAxis tick={{ fontSize: 12 }} />
                    <Tooltip
                        labelFormatter={(value: any) => moment(value).tz(timezone).format('D MMM')}
                    />
                    <Legend />
                    {allClids.map((key, index) =>
                        <Line key={key} dataKey={key} stroke={key == "none" ? "#aaa" : colors[index]} />)
                    }
                </LineChart>
            </ResponsiveContainer>
            <Box px={"15%"}>
                <Slider
                    value={days}
                    onChange={(e, newValue) => setDays(newValue as number)}
                    marks={[{ value: 30, label: "30" }, { value: 3 * 30, label: "90" }, { value: 6 * 30, label: "180" }, { value: 365, label: "365" }]}
                    // valueLabelDisplay="on"
                    step={null}
                    min={20} max={380}
                />
            </Box>
        </Box>)
}